export const dateFormat = process.env.REACT_APP_ACTIVE_REGION === "europe" ? 'MM-DD-YYYY' : 'DD-MM-YYYY'